import * as React from 'react';
import {emotionStyled} from '@packages/utilities/styled';
import {
  ChevronSmallDownIcon,
  ChevronSmallUpIcon,
} from '@packages/systems/spring';

const TickContainerView = emotionStyled('div')({
  alignItems: 'center',
  background: '$background1',
  borderTopRightRadius: 3,
  borderBottomRightRadius: 3,
  color: '$textPrimary',
  display: 'grid',
  gridTemplateRows: 'auto 1px auto',
  height: 'calc(100% - 2px)',
  justifyItems: 'center',
  minWidth: '$4',
  position: 'absolute',
  right: 1,
  top: 1,
  width: 16,
  zIndex: 1,
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '$actionSecondaryBackground',
    borderTopRightRadius: 3,
    borderBottomRightRadius: 3,
    zIndex: -1,
  },
});

const TickIconWrapperView = emotionStyled('div')(
  {
    alignItems: 'center',
    display: 'flex',
    height: 10,
    overflow: 'hidden',
    pointerEvents: 'none',
    '> div': {
      position: 'relative',
    },
  },
  {
    variants: {
      direction: {
        up: {
          '> div': {
            top: 0.5,
          },
        },
        down: {
          '> div': {
            top: -0.5,
          },
        },
      },
    },
  }
);

const TickAction = emotionStyled('div')(
  {
    color: '$textSecondary',
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
    '&:hover': {
      color: '$textPrimary',
      background: '$uiBackgroundHover',
    },
    '&:active': {
      background: 'transparent',
    },
  },
  {
    variants: {
      direction: {
        up: {
          borderTopRightRadius: 3,
        },
        down: {
          borderBottomRightRadius: 3,
        },
      },
    },
  }
);

const TickDivider = emotionStyled('div')({
  width: '100%',
  height: 1,
  background: '$border3',
});

const WebflowRightInputTickets = React.memo<{
  onTopClick: (arg1: React.MouseEvent<EventTarget>) => void;
  onBottomClick: (arg1: React.MouseEvent<EventTarget>) => void;
}>(function WebflowRightInputTickets({onTopClick, onBottomClick}) {
  return (
    <TickContainerView>
      <TickAction onClick={onTopClick} direction="up">
        <TickIconWrapperView direction="up">
          <ChevronSmallUpIcon />
        </TickIconWrapperView>
      </TickAction>
      <TickDivider />
      <TickAction onClick={onBottomClick} direction="down">
        <TickIconWrapperView direction="down">
          <ChevronSmallDownIcon />
        </TickIconWrapperView>
      </TickAction>
    </TickContainerView>
  );
});

export default WebflowRightInputTickets;
